//@flow
import React from 'react';
import Checkbox from '../../Form/components/Checkbox.react';
import QuoteActions from '../../Actions/quote';

type Props = {
  isMsrp:boolean,
  quoteId:?string,
  className?:string,
  id?:string,
};

export default class MsrpToggleButton extends React.Component<Props> {
  changePricing = (membershipPricing:boolean) => {
    if (!this.props.quoteId) return;
    QuoteActions.setMembershipPricing(this.props.quoteId, membershipPricing);
  }

  render() {
    const classname = this.props.className || '';
    const id = this.props.id || 'Msrp-toggle';
    return (
      <span className={`msrp-toggle-button ${classname}`}>
        <Checkbox
          checked={!this.props.isMsrp}
          setCheckboxState={this.changePricing}
          name="Msrp toggle"
          id={id}
          label=""
          className="msrp-toggle"
        />
      </span>
    );
  }
}
